import { render, staticRenderFns } from "./NoAttendeesView.vue?vue&type=template&id=1fbc2768"
import script from "./NoAttendeesView.vue?vue&type=script&lang=js"
export * from "./NoAttendeesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports